// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import store from '@/store'
import router from './router'
import ElementUI from 'element-ui'
Vue.use(ElementUI);
import 'element-ui/lib/theme-chalk/index.css'
import Axios from "axios"
Vue.prototype.$axios = Axios; //将axios挂载到原型上
import './utils/dialog'
import "./utils/directives.js";

import HmacUtils from './tools/hmac-utils.js'
Vue.prototype.$HmacUtils = HmacUtils; //python接口方法

//seo
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)
// token解析
var jwt = require('jsonwebtoken');
Vue.prototype.$jwt = jwt; //api

//自定义提示框
import Toast from "@/components/toast.js"
// Vue.use(Toast)
//传入对象参数
// this.$toast({
// 	type: 'success',
//     size: 'default',
//     message: '成功提示',
//     duration: 3000
// })
// this.$toast({
//     type: 'info',
//     size: 'default',
//     message: '消息提示',
//     duration: 3000
// })
// this.$toast({
//     type: 'warning',
//     size: 'default',
//     message: '警告提示',
//     duration: 3000
// })
// this.$toast({
//     type: 'error',
//     size: 'default',
//     message: '错误提示',
//     duration: 3000
// })

// //传入字符串参数（该参数会做为参数中message属性的值）
// this.$toast('提示消息')
//将Toast组件挂载到vue原型上
Vue.prototype.$toast = Toast

Vue.config.productionTip = false

import Api from '@/api/index.js';
Vue.prototype.$Api = Api; //接口请求地址

import types from '@/constants/types'
Vue.prototype.$types = types; //vuex action类型
/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: {
        App,
    },
    mounted() {
        document.dispatchEvent(new Event('render-event'));
      },
    template: '<App/>'
})
// new Vue({
//   router,
//   store,
//   render: h => h(App),
//   mounted() {
//       document.dispatchEvent(new Event('render-event'));
//     }
// }).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js